import { AUTH } from "./endpoint";
const { post } = require("./service-methods");

export const loginService = (request) => {
  return post(AUTH, request);
};
